
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import ImpfempfehlungenDetail from '@/components/Impfempfehlungen/ImpfempfehlungenDetail.vue';
    import Impfempfehlung from '@/types/Impfempfehlung';
    import { ImpfempfehlungFilter, LoadImpfempfehlungPayload } from '@/store/impfempfehlungen';
    import { DataTableHeaders } from '@/types';

    @Component({
        components: {
            ImpfempfehlungenDetail,
        },
        computed: {
            ...mapState('impfempfehlungen', ['impfempfehlungen', 'dialogs', 'loaders']),
        },
        methods: {
            ...mapActions('impfempfehlungen', ['loadImpfempfehlungen']),
            ...mapMutations('impfempfehlungen', ['setDialogsDetail']),
        },
    })
    export default class Impfempfehlungen extends Vue {
        public loadImpfempfehlungen!: (payload?: LoadImpfempfehlungPayload) => void;
        public setDialogsDetail!: (visible: boolean) => void;

        public impfempfehlung = new Impfempfehlung();
        public search = '';

        public filter: ImpfempfehlungFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Impfempfehlung> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Impfempfehlung', value: 'impfempfehlung' },
                { text: 'Gültig', value: 'gueltig' },
            ];
        }

        public mounted(): void {
            this.loadImpfempfehlungen();
        }

        public onChangeFilter(): void {
            this.loadImpfempfehlungen({ filter: this.filter });
        }

        public onClickEdit(impfempfehlung: Impfempfehlung): void {
            this.impfempfehlung = { ...impfempfehlung };
            this.setDialogsDetail(true);
        }

        public onClickNew(): void {
            this.impfempfehlung = new Impfempfehlung();
            this.setDialogsDetail(true);
        }
    }
